/* Branded Best House: the header's scrolled state, the proof line, and the sample mark on the homepage products.
   The load entrance is pure CSS. Progressive: without this file every element is already visible and still.
   Nick's logo studio (<bb-catalog-logo>) is only ever driven through its own methods; its code is unchanged. */
(function () {
  var root = document.documentElement;
  root.classList.add('bbh-js');

  // Header: a hairline appears once the page has moved. Desktop scrolls inside .page-wrapper, phone scrolls the window.
  var wrapper = document.querySelector('.page-wrapper');
  function onScroll() {
    var y = Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
    root.classList.toggle('bbh-scrolled', y > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var hero = document.querySelector("#MainContent [id$='__bb_catalog_logo']");
  if (!hero) return;

  // The promise sits beside the action, as its own line under the logo box.
  var cta = hero.querySelector('.bb-cl__cta-wrap');
  var line = root.getAttribute('data-bbh-proofline');
  if (cta && line && !hero.querySelector('.bbh-proofline')) {
    var p = document.createElement('p');
    p.className = 'bbh-proofline';
    p.textContent = line;
    cta.parentNode.insertBefore(p, cta);
  }

  // Help me choose: the gift finder, as a second quiet link beside the main one
  var finder = root.getAttribute('data-bbh-finder');
  var finderLabel = root.getAttribute('data-bbh-finder-label');
  if (cta && finder && finderLabel && !cta.querySelector('.bbh-finder-link')) {
    var a = document.createElement('a');
    a.className = 'bbh-finder-link';
    a.href = finder;
    var label = document.createElement('span');   // the gold strip sits under the words, like Nick's own button
    label.textContent = finderLabel;
    a.appendChild(label);
    cta.appendChild(a);
  }

  // The sample: a first-time visitor sees the Branded Best mark on every product until they add their own logo.
  // It goes through Nick's own useFile(file, false). "false" means not the visitor's pick, so his code never
  // saves it (BBLogoStore): it never follows them to a product page and can never be attached to an order.
  // A logo the visitor added before, or adds now, always wins (his logoSeq drops anything older).
  var sampleUrl = root.getAttribute('data-bbh-sample');
  var note = root.getAttribute('data-bbh-sample-note') || '';
  if (!sampleUrl || !window.customElements) return;

  customElements.whenDefined('bb-catalog-logo').then(function () {
    var cl = hero.querySelector('bb-catalog-logo');
    if (!cl || typeof cl.useFile !== 'function' || !window.BBLogoStore) return;
    var sampleFile = null;

    // While the sample is showing, CSS keeps "Add your logo" as the action and hides Nick's chip
    // (bb-catalog-logo[data-bbh-sample]), so the chip never flashes. The marker comes off the moment the visitor's own
    // logo takes over: any newer logoSeq (picker, paste or drop) or Nick's own save event.
    function watchForTheirs(seq) {
      var drop = function () { cl.removeAttribute('data-bbh-sample'); clearInterval(t); };
      var t = setInterval(function () { if (cl.logoSeq !== seq) drop(); }, 250);
      window.addEventListener('bb-logo:saved', drop, { once: true });
    }

    function backToAddState(seq) {
      var tries = 0;
      (function wait() {
        if (cl.logoSeq !== seq) return;          // the visitor added their own logo meanwhile
        if (cl.logo) {
          if (cl.drop) cl.drop.hidden = false;   // keep "Add your logo" as the action
          if (cl.chip) cl.chip.hidden = true;
          if (typeof cl.setStatus === 'function') cl.setStatus(note);
          return;
        }
        if (++tries < 100) setTimeout(wait, 100);
        else cl.removeAttribute('data-bbh-sample');
      })();
    }

    function applySample() {
      if (cl.logo) return;
      var seq0 = cl.logoSeq;                     // anything the visitor starts from here on wins
      window.BBLogoStore.load().then(function (stored) {
        if (stored || cl.logo || cl.logoSeq !== seq0) return;
        var go = function (file) {
          if (cl.logo || cl.logoSeq !== seq0) return;
          cl.setAttribute('data-bbh-sample', '');
          cl.useFile(file, false);
          watchForTheirs(cl.logoSeq);
          backToAddState(cl.logoSeq);
        };
        if (sampleFile) return go(sampleFile);
        fetch(sampleUrl).then(function (r) { if (!r.ok) throw new Error('sample missing'); return r.blob(); }).then(function (b) {
          sampleFile = new File([b], 'Branded Best (sample).png', { type: b.type || 'image/png' });
          go(sampleFile);
        }).catch(function () {});
      });
    }

    // after they remove their own logo, show the sample again
    var remove = cl.querySelector('[data-remove]');
    if (remove) remove.addEventListener('click', function () { setTimeout(applySample, 60); });

    // give Nick's own remembered-logo check a moment to run first
    setTimeout(applySample, 250);
  });
})();
